module.exports = __webpack_public_path__ + "img/DK27492649.6765a98c.png";